/* unplugin-vue-components disabled */import { render } from "./member_details.vue?vue&type=template&id=5dff6645&scoped=true"
import script from "./member_details.vue?vue&type=script&lang=js"
export * from "./member_details.vue?vue&type=script&lang=js"

import "./member_details.vue?vue&type=style&index=0&id=5dff6645&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dff6645"]])

export default __exports__